import { createFourierModel } from "./model";
import { samplePath } from "./math/samplePath";
import { invader } from "./shapes/invader";
import { fourierConfig } from "./config";

export const invaderModel = createFourierModel(invader, 0.88);
const raw = samplePath(invader, fourierConfig.sampleCount);
export const pixelTransform = {
  x: raw.reduce((a, p) => a + p.x / raw.length, 0),
  y: raw.reduce((a, p) => a + p.y / raw.length, 0),
  scale:
    1.76 /
    Math.max(
      Math.max(...raw.map((p) => p.x)) - Math.min(...raw.map((p) => p.x)),
      Math.max(...raw.map((p) => p.y)) - Math.min(...raw.map((p) => p.y)),
    ),
};
